import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Confirm from "../confirm/ConfirmController.jsx";
import { GlobalContext } from "../../globals/globalContext.jsx";

export default function Button(props) {
  const { colorPrimary } = useContext(GlobalContext) || props;
  let {
    className,
    label,
    onClick,
    disabled,
    transparent,
    plain,
    secondary,
    round,
    confirm,
    onConfirm,
    onAbort,
    confirmActive,
    confirmText,
    confirmButtonText,
    abortButtonText,
    bigfont,
    children,
    ...rest
  } = props;
  const classes = classNames(
    "button",
    {
      "is-round": round,
      "is-plain": plain,
      "is-transparent": transparent,
      "is-big-font": bigfont,
      "is-disabled": disabled,
      "is-secondary": secondary,
    },
    className,
  );
  return (
    <React.Fragment>
      {confirm && (
        <Confirm
          active={confirmActive}
          onConfirm={onConfirm}
          onAbort={onAbort}
          confirmButtonText={confirmButtonText}
          abortButtonText={abortButtonText}
        >
          {confirmText}
        </Confirm>
      )}

      <div
        className={classes}
        onClick={onClick}
        tabIndex={0}
        {...rest}
        style={{ backgroundColor: disabled ? null : colorPrimary }}
      >
        {label ? label : children}
      </div>
    </React.Fragment>
  );
}

Button.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};
